/* Mobile collection cards only: display labels, never plan values or selection. */
(() => {
  'use strict';
  const media = window.matchMedia('(max-width: 768px)');
  const selector = '.collection-grid-section product-card.product-card-wrapper .quick-add .loop-subscription-container select.loop-selling-plan-selector';
  const labels = new WeakMap();
  const names = new WeakMap();
  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (!scheduled) { scheduled = true; requestAnimationFrame(update); }
  });
  function update() {
    scheduled = false;
    observer.disconnect();
    document.querySelectorAll(selector).forEach(select => {
      if (!names.has(select)) names.set(select, select.getAttribute('aria-label'));
      if (media.matches) select.setAttribute('aria-label', 'Delivery frequency');
      else if (names.get(select) === null) select.removeAttribute('aria-label');
      else select.setAttribute('aria-label', names.get(select));
      Array.from(select.options).forEach(option => {
        if (!labels.has(option)) labels.set(option, option.textContent);
        const original = labels.get(option);
        const match = original.trim().match(/^(?:deliver\s+)?(?:every\s+)?(\d+)\s+weeks?$/i);
        const wanted = media.matches && match ? 'Every ' + match[1] + ' weeks' : original;
        if (option.textContent !== wanted) option.textContent = wanted;
      });
    });
    observer.observe(document.body, {childList:true, subtree:true, characterData:true});
  }
  media.addEventListener('change', update);
  update();
})();
